import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './app.css';
import { captureRef } from './referral/api';
import { I18nProvider } from './i18n/I18nProvider';
import { ThemeProvider } from './theme/ThemeProvider';
import { applyTheme, DEFAULT_THEME, loadTheme } from './theme/theme';

// 首次绘制前应用默认主题或已保存的选择，避免品牌色闪烁。
try {
  applyTheme(document.documentElement, loadTheme(localStorage));
} catch {
  applyTheme(document.documentElement, DEFAULT_THEME);
}

// **在渲染之前**把链接上的 ?ref= 捡走。放到组件里做的话，
// StrictMode 下会跑两次，而且路由改写 URL 之后可能已经把它丢了。
captureRef();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <App />
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
